import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdisedancab() {



  const cardData = {




keyword: "Pune to Shirdi Sedan Cabs",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Shirdi Sedan Cabs for devotees, families, couples, senior citizens, and small groups planning a convenient pilgrimage to Shirdi. Our chauffeur-driven sedans are suitable for one-way journeys, round trips, Sai Baba Darshan, family travel, and customized religious itineraries. With clean and well-maintained cars, experienced drivers, comfortable seating, practical luggage space, flexible Pune pickup locations, transparent pricing, and 24/7 customer assistance, we make the journey from Pune to Shirdi smooth and convenient. Travelers can also combine Shirdi with nearby temples, pilgrimage destinations, and sightseeing attractions while enjoying private door-to-door transportation.",

topPlaces: [
  {
    title: "Sai Baba Temple",
    description: "Sai Baba Temple is the principal pilgrimage attraction in Shirdi and welcomes devotees from across India throughout the year. Visitors come to the temple for Darshan, prayers, and spiritual experiences associated with Sai Baba. A private sedan from Pune is a comfortable choice for couples, small families, and senior citizens who prefer direct transportation and flexible travel timings."
  },
  {
    title: "Dwarkamai",
    description: "Dwarkamai is one of the most significant spiritual sites in Shirdi and is closely connected with the life and teachings of Sai Baba. The historic location attracts devotees who want to experience the peaceful atmosphere and religious heritage of the town. Travelers booking Pune to Shirdi Sedan Cabs can conveniently include Dwarkamai along with other nearby pilgrimage locations."
  },
  {
    title: "Chavadi",
    description: "Chavadi is an important religious landmark associated with Sai Baba and forms part of the traditional Shirdi pilgrimage experience. The site is located near the main temple area and is visited by devotees during their stay. Garud Cab Service provides comfortable sedan transportation for travelers who want to explore the important spiritual places of Shirdi at their own pace."
  },
  {
    title: "Khandoba Temple",
    description: "Khandoba Temple is a historic religious site in Shirdi dedicated to Lord Khandoba and holds an important place in the spiritual heritage of the town. It is a convenient addition to a Shirdi Darshan itinerary for devotees and visitors interested in local religious history. A chauffeur-driven sedan allows passengers from Pune to travel comfortably between different attractions."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a renowned pilgrimage destination dedicated to Lord Shani and is frequently combined with Shirdi during religious journeys in Maharashtra. The temple attracts devotees throughout the year and offers a distinctive spiritual experience. Customers can book a Pune to Shirdi sedan cab and customize the journey to include Shani Shingnapur as an additional pilgrimage stop."
  },
  {
    title: "Nashik",
    description: "Nashik is a major religious and cultural destination in Maharashtra known for Panchavati, sacred temples, Godavari ghats, and nearby Trimbakeshwar. Travelers can extend their Pune to Shirdi pilgrimage by including Nashik in their itinerary. A sedan is suitable for couples and small families who want comfortable private transportation between multiple destinations."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a revered Shiva pilgrimage destination near Nashik and is home to one of the twelve Jyotirlingas. Devotees visiting Shirdi can combine Trimbakeshwar with their journey for an extended spiritual tour. Garud Cab Service provides chauffeur-driven sedan travel for passengers who want to cover both destinations with flexible pickup, sightseeing, and return arrangements."
  },
  {
    title: "Sinnar",
    description: "Sinnar is a historic town in Maharashtra located along the route connecting important destinations in the Pune-Nashik region. The area is known for religious and heritage attractions, including traditional temples and historic architecture. Travelers can include Sinnar as a stop during a customized Pune to Shirdi journey when they want to explore additional destinations along the route."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are a UNESCO World Heritage Site featuring remarkable Buddhist, Hindu, and Jain rock-cut monuments, with the Kailasa Temple being one of the major highlights. Travelers planning a longer Maharashtra pilgrimage can combine Ellora with Shirdi and other religious destinations. A sedan cab provides convenient private transportation for couples and small families carrying moderate luggage."
  },
  {
    title: "Grishneshwar Jyotirlinga",
    description: "Grishneshwar Jyotirlinga is a revered Lord Shiva temple located near Ellora and is traditionally counted among the twelve Jyotirlingas. Devotees often combine Grishneshwar with Shirdi when planning an extended religious journey through Maharashtra. Garud Cab Service can arrange a comfortable sedan for multi-destination travel, allowing passengers to follow a personalized pilgrimage schedule."
  }
],




"services": [
{
"name": "Shirdi Sedan Cab from Pune",
"description": "Book Shirdi Sedan Cab from Pune for a comfortable and convenient pilgrimage journey with professional chauffeurs and well-maintained air-conditioned sedan cars. The service is suitable for Sai Baba darshan, family trips, senior passengers, tourists, one-way transfers, and round-trip journeys."
},
{
"name": "Pune to Shirdi Sedan Taxi Service",
"description": "Choose Pune to Shirdi Sedan Taxi Service for private and comfortable transportation with experienced drivers, AC interiors, convenient pickup, and direct destination drop. The service is suitable for families, couples, senior citizens, devotees, and travelers planning a Shirdi pilgrimage."
},
{
"name": "Pune to Shirdi Darshan Cab",
"description": "Book Pune to Shirdi Darshan Cab for a convenient private journey planned around your Sai Baba darshan schedule. Enjoy comfortable AC sedan travel, professional chauffeur service, flexible pickup arrangements, and suitable transportation for families, devotees, senior passengers, and groups."
},
{
"name": "Pune to Shirdi Sai Baba Cab",
"description": "Reserve Pune to Shirdi Sai Baba Cab for a comfortable pilgrimage journey from Pune to Shirdi with a professional chauffeur. Enjoy clean AC sedan interiors, convenient door-to-door pickup, luggage space, and flexible travel arrangements for devotees, families, couples, and senior passengers."
},
{
"name": "Pune to Shirdi Tourist Taxi",
"description": "Hire Pune to Shirdi Tourist Taxi for comfortable private transportation with an experienced chauffeur and air-conditioned sedan. The service is suitable for pilgrims, tourists, families, couples, and groups visiting Shirdi for Sai Baba darshan, sightseeing, personal visits, and religious travel."
},
{
"name": "Pune to Shirdi Budget Sedan Cab",
"description": "Choose Pune to Shirdi Budget Sedan Cab for an economical and comfortable outstation journey with a professional chauffeur. Enjoy AC travel, practical luggage space, convenient pickup, and reliable transportation for individuals, couples, families, devotees, and small groups traveling to Shirdi."
},
{
"name": "Pune to Shirdi Outstation Taxi",
"description": "Book Pune to Shirdi Outstation Taxi for dependable long-distance transportation with professional chauffeurs and comfortable AC sedan vehicles. The service is suitable for pilgrimage trips, family travel, personal visits, sightseeing, one-way transfers, and round-trip journeys from Pune to Shirdi."
},
{
"name": "Pune to Shirdi Sedan Car Hire",
"description": "Hire Pune to Shirdi Sedan Car with a professional chauffeur for a private and relaxed pilgrimage journey. Enjoy comfortable seating, AC interiors, convenient pickup, luggage space, and flexible travel arrangements suitable for families, devotees, senior passengers, tourists, and couples."
},
{
"name": "Pune to Shirdi One Day Trip Cab",
"description": "Book Pune to Shirdi One Day Trip Cab for a convenient same-day pilgrimage journey with private chauffeur-driven transportation. Enjoy comfortable AC sedan travel, flexible pickup and return arrangements, and a practical travel option for Sai Baba darshan, family trips, and short religious tours."
},
{
"name": "Pune to Shirdi Family Tour Cab",
"description": "Choose Pune to Shirdi Family Tour Cab for comfortable and private family transportation with spacious seating, AC interiors, luggage capacity, and an experienced chauffeur. The service is suitable for families traveling with children, senior citizens, and relatives for Sai Baba darshan and religious visits."
},
{
"name": "Pune to Shirdi Sedan Cab",
"description": "Book Pune to Shirdi Sedan Cab for reliable and comfortable outstation transportation with a professional driver and well-maintained AC vehicle. The sedan is suitable for individuals, couples, families, devotees, tourists, and small groups planning one-way or round-trip travel to Shirdi."
},
{
"name": "Pune to Shirdi Sedan Taxi",
"description": "Reserve Pune to Shirdi Sedan Taxi for a smooth private journey with convenient pickup and direct destination drop. Enjoy air-conditioned seating, professional chauffeur service, practical luggage space, and flexible travel options for pilgrimage trips, family visits, sightseeing, and personal travel."
},
{
"name": "Pune to Shirdi Sedan Cab Service",
"description": "Choose Pune to Shirdi Sedan Cab Service for dependable chauffeur-driven transportation with clean AC vehicles and convenient pickup arrangements. The service is suitable for Sai Baba devotees, families, senior passengers, tourists, couples, and groups requiring comfortable private travel from Pune to Shirdi."
},
{
"name": "Pune to Shirdi Taxi Service",
"description": "Book Pune to Shirdi Taxi Service for comfortable and reliable pilgrimage transportation with experienced chauffeurs and well-maintained air-conditioned vehicles. Enjoy convenient door-to-door pickup and suitable sedan options for darshan, family journeys, personal visits, sightseeing, and planned return travel."
},
{
"name": "Pune to Shirdi Cab Booking",
"description": "Make Pune to Shirdi Cab Booking for a scheduled private journey with convenient pickup and direct drop facilities. Select a comfortable sedan according to your passenger count and luggage requirements while enjoying professional chauffeur service for Sai Baba darshan, family travel, and religious trips."
},
{
"name": "Pune to Shirdi One Way Sedan Cab",
"description": "Book Pune to Shirdi One Way Sedan Cab for a direct point-to-point journey without arranging return transportation. Enjoy comfortable AC travel, professional chauffeur service, convenient pickup from homes, offices, hotels, or other Pune locations, and direct drop at your preferred destination in Shirdi."
},
{
"name": "Pune to Shirdi Round Trip Sedan Cab",
"description": "Reserve Pune to Shirdi Round Trip Sedan Cab for convenient return transportation according to your darshan and sightseeing schedule. Enjoy private AC travel, professional chauffeur service, comfortable seating, and flexible pickup arrangements for families, devotees, senior passengers, couples, and small groups."
},
{
"name": "Pune to Shirdi Darshan Sedan Cab",
"description": "Choose Pune to Shirdi Darshan Sedan Cab for a comfortable private journey focused on Sai Baba pilgrimage travel. The service provides AC sedan transportation, experienced chauffeur support, convenient pickup, and flexible travel arrangements for devotees, families, senior citizens, and tourists."
},
{
"name": "Pune to Shirdi Outstation Sedan Cab",
"description": "Book Pune to Shirdi Outstation Sedan Cab for comfortable intercity travel with a professional chauffeur and well-maintained AC sedan. The vehicle is suitable for one-way journeys, round trips, pilgrimage travel, family visits, sightseeing, business travel, and personal trips to Shirdi."
},
{
"name": "Pune to Shirdi Online Cab Booking",
"description": "Make Pune to Shirdi Online Cab Booking for convenient private transportation with scheduled pickup and direct destination drop. Choose a comfortable sedan for Sai Baba darshan, family travel, religious tours, sightseeing, and personal journeys while planning your preferred travel date and timing."
},
{
"name": "Pune to Shirdi Sedan Cab with Driver",
"description": "Hire Pune to Shirdi Sedan Cab with Driver for a stress-free pilgrimage journey in a comfortable air-conditioned vehicle. Enjoy professional chauffeur service, convenient pickup, comfortable seating, practical luggage space, and direct transportation suitable for families, devotees, couples, and senior passengers."
},
{
"name": "AC Sedan Cab from Pune to Shirdi",
"description": "Book AC Sedan Cab from Pune to Shirdi for a comfortable and relaxing outstation journey with air-conditioned interiors and professional chauffeur service. The sedan provides practical seating and luggage space for devotees, families, couples, tourists, and passengers traveling for Sai Baba darshan."
},
{
"name": "Pune to Shirdi Swift Dzire Cab",
"description": "Choose Pune to Shirdi Swift Dzire Cab for economical and comfortable private transportation with a professional chauffeur. Swift Dzire provides AC seating, practical luggage space, and convenient travel for individuals, couples, small families, devotees, and passengers planning one-way or round-trip Shirdi journeys."
},
{
"name": "Pune to Shirdi Hyundai Aura Cab",
"description": "Book Pune to Shirdi Hyundai Aura Cab for a comfortable chauffeur-driven sedan journey with air-conditioned interiors and practical luggage capacity. The vehicle is suitable for families, couples, devotees, senior passengers, tourists, and small groups traveling from Pune to Shirdi for darshan or personal visits."
},
{
"name": "Pune to Shirdi Honda Amaze Cab",
"description": "Reserve Pune to Shirdi Honda Amaze Cab for comfortable private transportation with an experienced chauffeur and clean AC interiors. Honda Amaze offers a practical sedan option for families, couples, devotees, senior travelers, and small groups planning a convenient Shirdi pilgrimage from Pune."
},
{
"name": "Pune to Shirdi Same Day Darshan Cab",
"description": "Book Pune to Shirdi Same Day Darshan Cab for a convenient return journey planned around your Sai Baba darshan schedule. Enjoy private AC sedan travel, professional chauffeur service, flexible pickup, and return transportation suitable for families, devotees, couples, and senior passengers."
},
{
"name": "Best Sedan Cab Service Pune to Shirdi",
"description": "Choose Best Sedan Cab Service Pune to Shirdi for comfortable chauffeur-driven pilgrimage transportation with clean AC vehicles, experienced drivers, convenient pickup, and flexible travel arrangements. The service is suitable for families, devotees, senior citizens, couples, tourists, and small groups."
},
{
"name": "Pune to Shirdi Round Trip Sedan Taxi",
"description": "Reserve Pune to Shirdi Round Trip Sedan Taxi for convenient return transportation with a private AC sedan and professional chauffeur. Plan your journey according to your darshan schedule and enjoy comfortable seating, luggage space, flexible pickup, and reliable transportation for family and pilgrimage trips."
},
{
"name": "Pune to Shirdi Online Sedan Cab Booking",
"description": "Make Pune to Shirdi Online Sedan Cab Booking for scheduled private transportation with a comfortable air-conditioned sedan and professional driver. The service is suitable for Sai Baba darshan, family travel, senior passengers, couples, tourists, one-way journeys, and round-trip pilgrimage plans."
},
{
"name": "Affordable Sedan Taxi Pune to Shirdi",
"description": "Book Affordable Sedan Taxi Pune to Shirdi for economical and comfortable private travel with a professional chauffeur. Enjoy AC interiors, convenient pickup, practical luggage space, and reliable transportation for devotees, families, couples, senior passengers, and small groups visiting Shirdi."
},
{
"name": "Pune to Shani Shingnapur Cab",
"description": "Choose Pune to Shani Shingnapur Cab for a comfortable private pilgrimage journey to the famous Shani temple with an experienced chauffeur. Enjoy AC sedan transportation, convenient pickup, flexible travel arrangements, and suitable vehicle options for families, devotees, senior passengers, and groups."
},
{
"name": "Pune to Ahmednagar Cab",
"description": "Book Pune to Ahmednagar Cab for convenient intercity transportation with professional chauffeurs and well-maintained AC sedan vehicles. The service is suitable for business travel, family visits, personal journeys, sightseeing, religious trips, one-way transfers, and round-trip travel from Pune to Ahmednagar."
}
],
"tableData": [
["Shirdi Sedan Cab from Pune", "Pune to Shirdi Sedan Taxi Service"],
["Pune to Shirdi Darshan Cab", "Pune to Shirdi Sai Baba Cab"],
["Pune to Shirdi Tourist Taxi", "Pune to Shirdi Budget Sedan Cab"],
["Pune to Shirdi Outstation Taxi", "Pune to Shirdi Sedan Car Hire"],
["Pune to Shirdi One Day Trip Cab", "Pune to Shirdi Family Tour Cab"],
["Pune to Shirdi Sedan Cab", "Pune to Shirdi Sedan Taxi"],
["Pune to Shirdi Sedan Cab Service", "Pune to Shirdi Taxi Service"],
["Pune to Shirdi Cab Booking", "Pune to Shirdi One Way Sedan Cab"],
["Pune to Shirdi Round Trip Sedan Cab", "Pune to Shirdi Darshan Sedan Cab"],
["Pune to Shirdi Outstation Sedan Cab", "Pune to Shirdi Online Cab Booking"],
["Pune to Shirdi Sedan Cab with Driver", "AC Sedan Cab from Pune to Shirdi"],
["Pune to Shirdi Swift Dzire Cab", "Pune to Shirdi Hyundai Aura Cab"],
["Pune to Shirdi Honda Amaze Cab", "Pune to Shirdi Same Day Darshan Cab"],
["Best Sedan Cab Service Pune to Shirdi", "Pune to Shirdi Round Trip Sedan Taxi"],
["Pune to Shirdi Online Sedan Cab Booking", "Affordable Sedan Taxi Pune to Shirdi"],
["Pune to Shani Shingnapur Cab", "Pune to Ahmednagar Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Shirdi Sedan Cabs for a Peaceful Pilgrimage",
    WhyChoosedescription: "Garud Cab Service offers private sedan cabs from Pune to Shirdi for Sai Baba darshan, family pilgrimages, senior citizen travel, couple trips, and devotee groups seeking a comfortable journey."
  },
  {
    WhyChooseheading: "Private Journey with Flexible Timings",
    WhyChoosedescription: "Travel directly from your preferred Pune location to Shirdi without sharing the vehicle with other passengers. Departure and return timings can be planned around your darshan schedule."
  },
  {
    WhyChooseheading: "Comfortable Option for Small Groups",
    WhyChoosedescription: "A sedan is a practical choice for individuals, couples, and small families travelling to Shirdi with moderate luggage and looking for a private vehicle."
  },
  {
    WhyChooseheading: "Convenient for Senior Devotees",
    WhyChoosedescription: "Private sedan travel allows elderly passengers to enjoy a more relaxed journey with convenient pickup, comfortable seating, and the flexibility to include suitable rest breaks."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Shirdi Cabs",
    WhyChoosedescription: "Book a one-way sedan when you only need a drop at Shirdi, or select a round-trip arrangement for returning to Pune after completing your Sai Baba darshan."
  },
  {
    WhyChooseheading: "Pickup from Home, Hotel or Office",
    WhyChoosedescription: "Garud Cab Service can arrange pickup from your preferred Pune location, including homes, hotels, offices, residential societies, and other convenient points."
  },
  {
    WhyChooseheading: "Flexible Religious Tour Planning",
    WhyChoosedescription: "If you have additional time, your journey can be planned around nearby religious or sightseeing destinations, allowing you to make better use of your pilgrimage schedule."
  },
  {
    WhyChooseheading: "Book Your Shirdi Sedan with Garud",
    WhyChoosedescription: "Provide your Pune pickup point, Shirdi destination, travel date, passenger count, darshan schedule, and one-way or return requirement to arrange your sedan cab."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Shirdi Sedan Cabs?",
    answer: "Yes, Garud Cab Service provides sedan cabs from Pune to Shirdi for Sai Baba darshan, family pilgrimages, senior citizens, couples, and small groups."
  },
  {
    question: "Can I book a one-way sedan from Pune to Shirdi?",
    answer: "Yes, one-way sedan cab service is available for passengers who require direct transportation from Pune to Shirdi."
  },
  {
    question: "Can I book a round-trip sedan to Shirdi?",
    answer: "Yes, round-trip sedan arrangements can be planned according to your darshan schedule and preferred return timing."
  },
  {
    question: "Is a sedan suitable for senior citizens travelling to Shirdi?",
    answer: "Yes, private sedan travel can be convenient for senior devotees because it provides direct transportation, comfortable seating, and flexibility for breaks."
  },
  {
    question: "Can families book a private Shirdi sedan?",
    answer: "Yes, families can book a dedicated sedan based on their passenger count, luggage, and comfort requirements."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, or another preferred location in Pune."
  },
  {
    question: "Can I plan other religious places with the Shirdi trip?",
    answer: "Yes, additional religious or sightseeing destinations can be discussed while preparing your itinerary, depending on the available time and selected route."
  },
  {
    question: "Can I book a same-day Pune to Shirdi return cab?",
    answer: "Yes, a same-day return arrangement can be discussed based on your departure time, darshan schedule, and overall travel plan."
  },
  {
    question: "Is the sedan suitable for couples visiting Shirdi?",
    answer: "Yes, a private sedan is a comfortable option for couples who want a dedicated vehicle and flexible travel timings for their pilgrimage."
  },
  {
    question: "How can I book a Pune to Shirdi Sedan Cab?",
    answer: "Share your Pune pickup location, travel date, passenger details, preferred sedan, and one-way or round-trip requirement with Garud Cab Service to arrange your booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Kulkarni",
    feedback: "We booked a sedan from Pune to Shirdi for our family darshan. The private vehicle was comfortable and especially convenient for travelling with our parents.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Patil",
    feedback: "My family arranged a round-trip Shirdi sedan from Pune. The direct pickup and flexible return timing helped us manage our darshan plans comfortably.",
    rating: 5
  }
];






  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Sedan Cabs",
  "image": "https://garudcabs.com/assets/images/pune-to-shirdi-sedan-cabs.webp",
  "description": "Book Pune to Shirdi Sedan Cabs with Garud Cab for a comfortable and reliable pilgrimage journey. Get Sedan taxi services from Pune to Shirdi for Sai Baba Darshan, tourist travel, one way trips, and round trips with convenient pickup and drop options for families, couples, and small groups.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-shirdi-sedan-cabs"
  }
};




  return (
    <div>


<Helmet>
  <title>Pune to Shirdi Sedan Cabs | Darshan & Taxi Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Shirdi Sedan Cabs with Garud Cab for comfortable pilgrimage travel. Get Sedan taxi services for Shirdi Sai Baba Darshan, tourist trips, one way and round trip journeys from Pune with convenient pickup and drop."
  />

  <meta
    name="keywords"
    content="Shirdi Sedan Cab from Pune, Pune to Shirdi Sedan Taxi Service, Pune to Shirdi Darshan Cab, Pune to Shirdi Sai Baba Cab, Pune to Shirdi Tourist Taxi, Pune to Shirdi Sedan Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdisedancab;